import { render, staticRenderFns } from "./form-loader.vue?vue&type=template&id=afd7d452&"
import script from "./form-loader.ts?vue&type=script&lang=ts&"
export * from "./form-loader.ts?vue&type=script&lang=ts&"
import style0 from "./form-loader.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports